/**
 * Student Hub — מסלול הלמידה (/learn)
 *
 * The school programme is just one portal track, so this is a thin wrapper over
 * the generic hub. Kept as its own file so the /learn routes and every existing
 * link keep working untouched.
 */

import TrackHubPage from './track/TrackHubPage'

export default function StudentHubPage() {
  return <TrackHubPage track="student" />
}
